import { render, staticRenderFns } from "./MyDropdown.vue?vue&type=template&id=a88e8142"
import script from "./MyDropdown.vue?vue&type=script&lang=js"
export * from "./MyDropdown.vue?vue&type=script&lang=js"
import style0 from "./MyDropdown.vue?vue&type=style&index=0&id=a88e8142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports